import { FormKitNode } from '@formkit/core'
import FormKitUpload from './FormKitUpload.vue'
import FormKitSignature from './FormKitSignature.vue'
import { createInput } from '@formkit/vue'
import { undefine } from '@formkit/utils'
import { gsgPhone } from './gsg-phone.ts'
import { gsgTableOptions } from './gsg-table-options.ts'

const gsgInputsPlugin = (node: FormKitNode) => {
  // This is necessary to support the Vue boolean shorthand syntax:
  // https://github.com/formkit/formkit/issues/753
  node.props.multiple = undefine(node.props.multiple)
}

gsgInputsPlugin.library = (node: FormKitNode) => {
  if (node.props.type === 'gsg-upload') {
    node.define(createInput(FormKitUpload, {
      // See gsg-upload-input.d.ts for prop documentation
      props: [
        'fileTypes',
        'maxFileSize',
        'multiple',
        'sourceTag',
        'retainUntil',
      ],
    }))
  }
  if (node.props.type === 'gsg-phone') {
    node.define(gsgPhone)
  }
  if (node.props.type === 'gsg-table-options') {
    node.define(gsgTableOptions)
  }
  if (node.props.type === 'gsg-signature') {
    node.define(createInput(FormKitSignature, {
      // See FormKitSignature.d.ts for prop documentation
      props: [
        'sourceTag',
        'retainUntil',
      ],
    }))
  }
}

/**
 * A FormKit plugin that registers all of the custom GSG FormKit input types.
 */
export default gsgInputsPlugin
